import React, { useEffect, useState } from "react";
import logo from "../img/easyILA_Logo.svg";
import logoLight from "../img/easyILA_Logo_White.svg";
import { Link } from "react-router-dom";
import Loader from "../components/loader";
import { Helmet } from "react-helmet-async";
import Navbar from "./Header/Navbar-1";
import Footer from "./Footer";
import CollapseHeaders from "./collapse-header";

const NewDisclaimer = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handlePageLoad = () => {
      setIsLoading(false);
    };

    if (document.readyState === "complete") {
      setIsLoading(false);
    } else {
      window.addEventListener("load", handlePageLoad);
    }

    return () => window.removeEventListener("load", handlePageLoad);
  }, []);

  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imageHeight = windowWidth <= 768 ? "50px" : "90px";

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Helmet>
        <title>Disclaimer - easyILA</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div>
        {/* Header Section */}
        <CollapseHeaders />

        <div className="terms-and-conditions" style={{ paddingTop: "100px" }}>
          <div className="container">
            <div className="row video_main">
              <div className="col-md-12">
                <div className="row">
                  <h1 className="terms_heading">Disclaimer</h1>
                  <div class="col-lg-12">
                    <p class="terms_text">
                      The information contained in this website and the
                      communications is provided for informational purposes
                      only, and should not be construed as legal advice on any
                      matter.
                    </p>
                    <p class="terms_text">
                      The transmission and receipt of information contained on
                      this Web site, in whole or in part, or communication with
                      easyila.com or esmsys LLC via the Internet or e-mail
                      through this website does not constitute or create a
                      lawyer-client relationship between us and any recipient.
                      You should not send us any confidential information in
                      response to this webpage. Such responses will not create a
                      lawyer-client relationship, and whatever you disclose to
                      us will not be privileged or confidential unless we have
                      agreed to act as your legal counsel and you have executed
                      a written engagement agreement with appropriate management
                      of easyila.com. The material on this website may not
                      reflect the most current legal developments. The content
                      and interpretation of the law addressed herein is subject
                      to revision. We disclaim all liability in respect to
                      actions taken or not taken based on any or all the
                      contents of this site to the fullest extent permitted by
                      law. Do not act or refrain from acting upon this
                      information without seeking professional legal counsel.
                    </p>
                    <p class="terms_text">
                      esmsys LLC and / or its parent organizations and / or
                      subsidiaries, affiliates, associations, partner firms,
                      consultants, service providers, hereby disclaims any
                      liability resulting from or arising out of
                      your/representative use or attempted use of its web site
                      easyila.com, including, without limitation, the loss,
                      dissemination, or misuse by another of any kind of
                      personal, medical, or financial or business or technical
                      or non-technical information. esmsys LLC further disclaims
                      any warranties, express or implied, with respect to the
                      service it offers. By way of example, and not limitation,
                      your or your representative's use of easyila.com does not
                      create a lawyer-client relationship with
                      you/representative/organization or constitute the
                      dispensing of legal advice. esmsys LLC endeavors to
                      provide comprehensive and timely information but is not
                      liable for law, lawyer, attorney changes to their
                      respective terms and conditions of treatment or cost, or
                      changes by governing bodies, laws or acts, with regard to
                      legal requirements, processes, compliances or its list of
                      approved or authorized attorneys / lawyers.
                    </p>

                    <h2 class="terms_condition_1">
                      Social media channels disclaimer
                    </h2>
                    <p class="terms_text">
                      Media posted on our social media channels and/or our
                      website is intended for a general overview and discussion
                      of the subjects dealt with, and does not create a
                      lawyer-client relationship. It is not intended to be, and
                      should not be used as, a substitute for taking legal
                      advice in any specific situation. esmsys LLC will accept
                      no responsibility for any actions taken or not taken on
                      the basis of this publication. All content, posts, videos,
                      podcasts or any other media published by esmsys remain our
                      copyright and all rights are reserved. The logos and
                      trademarks are properties of their respective owners. The
                      views expressed therein may belong to the author and/or
                      sources, for which esmsys or easyILA do not take any
                      liability. Information belonging to the sources remain
                      property and rights of the sources.
                    </p>
                    <h2 class="terms_condition_1">Map policy</h2>
                    <p class="terms_text">
                      The map used on our website/media/email is published on
                      the web by organizations such as Google, Wikimapia, etc,
                      and sourced under an open licence or as practical. The
                      boundaries and names shown and the designations used on
                      this map do not imply the expression of any opinion
                      whatsoever on the part of esmsys or its people in respect
                      of the legal status of any country, territory, city or
                      area, or the delimitation of any frontiers or boundaries.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Privacy Policy End */}

        {/* Footer Section Start */}
        <Footer />

        {/* Footer Section End */}

        {/* Go To Top Link */}
        <a href="#" className="back-to-top">
          <i className="lnr lnr-arrow-up"></i>
        </a>
      </div>
    </>
  );
};

export default NewDisclaimer;
